// Query keys and cache writes for the crew flow. Every crew mutation answers with
// the whole CrewRequestView, so pages put that straight into the cache instead of
// refetching.
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../services/api';
import type { CrewRequestView } from './types';

export const crewKey = (rid: string) => ['crew-request', rid] as const;

export function useCrewRequest(rid: string) {
  return useQuery({ queryKey: crewKey(rid), queryFn: () => api.crewRequest(rid), retry: false });
}

export function useSetCrewRequest(rid: string) {
  const qc = useQueryClient();
  return (v: CrewRequestView) => {
    qc.setQueryData(crewKey(rid), v);
    // my papers and shares change with every answer
    qc.invalidateQueries({ queryKey: ['papers-me'] });
  };
}
